module.exports = __webpack_public_path__ + "img/1.712d4fbb.jpg";